import React, { useEffect, useState } from "reactn";
import { useParams } from 'react-router-dom'
import { Row, Col, Form, Input, Button, Card, message, Select, InputNumber, Typography, List, Avatar } from 'antd';
import { useHistory } from 'react-router-dom';
import { LeftOutlined } from "@ant-design/icons";
import { Link } from 'react-router-dom';
import { useCallback } from "react";
import { doc, getDoc, collection, query, where, getDocs, setDoc, get } from "firebase/firestore";
import firebaseDb from '../firebase';

const StreamCodeDetail = (props) => {
    let params = useParams()
    let history = useHistory()
    let id = params.id !== "add" ? params.id : false;
    let streamId = params.streamId

    let newRecord = {
        limit: 1
    }

    let [data, setData] = useState(id ? {} : newRecord);
    let [dataUsers, setDataUsers] = useState([]);
    let [errors, setErrors] = useState([]);
    let [loading, setLoading] = useState(id ? true : false);
    let [validationCheck, setValidationCheck] = useState(false)
    let [valid, setValid] = useState()

    //onetime run
    useEffect(() => {
        if (id) {
            setLoading(true)
            get()
        }
    }, [id]);

    let get = async () => {
        const codeRef = doc(firebaseDb, "code/" + streamId + "/codes", id);
        const codeSnap = await getDoc(codeRef);
        if (codeSnap.exists()) {
            let code = { ...codeSnap.data(), id: codeSnap.id, code: codeSnap.id }
            setData(code)
            if (code && code.users && code.users.length > 0) {
                let users = []
                for (const user of code.users) {
                    const userRef = collection(firebaseDb, 'users');
                    const userQuery = query(userRef, where("uuid", "==", user));
                    const userSnaps = await getDocs(userQuery);
                    let username = ""
                    if (userSnaps.docs.length > 0) {
                        const userSnap = userSnaps.docs[0]
                        if (userSnap.exists()) {
                            username = [userSnap.data().name, userSnap.data().surname].filter(x => x).join('  ')
                            users.push({
                                id: user,
                                username: username,
                                url: userSnap.data().profileImageUrl
                            })
                        }
                    }
                }
                setDataUsers(users);
            }

            setLoading(false)
        }
    }

    useEffect(() => {
        if (!id && data.code) {
            getValid()
        }
    }, [data]);


    let getValid = async () => {
        const codeRef = doc(firebaseDb, "code/" + streamId + "/codes", data.code);
        await getDoc(codeRef).then(codeSnap => {
            if (codeSnap.exists())
                setValid(true)
            else
                setValid(false)
        })
    }

    let validate = useCallback(() => {
        let errors = {};

        if (data.code === undefined )
            errors.code = 'Zorunlu Alan!'

        if (valid)
            errors.code = 'Bu kod daha önce kullanılmış, limit artırmak için düzenleme işlemi yapınız!'

        errors.all = Object.getOwnPropertyNames(errors).map(n => errors[n]);
        errors.hasError = errors.all.length > 0;
        return errors;
    }, [valid, data]);

    useEffect(() => { if (validationCheck) setErrors(validate()) }, [validationCheck, data, validate]);

    let save = async () => {
        setValidationCheck(true)
        let err = validate()
        if (err.hasError) {
            setErrors(err)
            window.scrollTo({ top: 20, behavior: 'smooth' });
        }
        else {
            if (id) {
                await setDoc(doc(firebaseDb, "code/" + streamId + "/codes", data.code), { ...data });
                message.success("Bilgiler eklendi", 2);
                history.push("/streams/codes/" + streamId)
            }
            else {

                await setDoc(doc(firebaseDb, "code/" + streamId + "/codes", data.code), { users: [], limit: data.limit });
                message.success("Bilgiler eklendi", 2);
                history.push("/streams/codes/" + streamId)
            }
        }
    };

    const { Option } = Select;

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Kodlar"}</h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Link to={"/streams/codes/" + streamId}>
                        <Button className="button4" type="light" icon={<LeftOutlined />} size="large">GERİ</Button>
                    </Link>
                </div>

            </div>
            <div className="form-wrap">
                <Card title={id ? "Düzenle" : "Ekle"} loading={loading}>
                    <Form layout="horizontal" size={"large"} onFinish={save}>

                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="code" required help={errors.code} validateStatus={errors.code ? 'error' : 'success'}>
                                    <Input className="button4" disabled={id ? true : false} name="code" value={data.code} onChange={e => setData({ ...data, code: e.target.value })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                <Form.Item label="Limit" help={"Boş bırakakıldığında tek kullanımlık olur."}>
                                    <InputNumber name="limit" value={data.limit} onChange={v => setData({ ...data, limit: v })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="Kullanıcılar">
                                    <List
                                        itemLayout="horizontal"
                                        dataSource={dataUsers}
                                        renderItem={item => (
                                            <List.Item>
                                                <List.Item.Meta
                                                    avatar={<Avatar src={item.url ? item.url: "https://futurelive-api.eventapp.app/files/avatar.png"} />}
                                                    title={<a href="https://ant.design">{item.username}</a>}
                                                    description={"id: " + item.id}
                                                />
                                            </List.Item>
                                        )}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col span={24}>
                                <Form.Item>
                                    <Button className="button4" type="primary" disabled={loading} htmlType="submit" size="large" block > KAYDET </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </div>
        </div>
    );
};

export default StreamCodeDetail;
